import $ from 'jquery';
import slick from 'slick-carousel';

export default function slider() {
  
  function hero() {
    $('#slider-hero').slick({
      arrows: false,
      dots: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 1
    });
  }
  
  function day() {
    $('#slider-day').slick({
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev"></button>',
      nextArrow: '<button type="button" class="slick-next"></button>',
      dots: false,
      infinite: false,
      slidesToShow: 14,
      slidesToScroll: 7,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 7,
            slidesToScroll: 5
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5
          }
        },
        {
          breakpoint: 380,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  
  $( document ).ready(function() {
    if($('#slider-hero').length > 0) {
      hero();
    }
    
    if($('#slider-day').length > 0) {
      day();
      var slideno = $('#slider-day').data('day');
      $('#slider-day').slick('slickGoTo', slideno - 1);
    }
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/slider.js